<app-loading-modal
	*ngIf="loading$ | async"
	class="absolute"
></app-loading-modal>

<div class="sm:hidden flex flex-col items-center p-5 print-hidden">
	<div class="w-32 mb-14">
		<img
			src="/assets/images/closer-logos/closer-logo-full.webp"
			alt="Closer"
			class="login-header__logo"
		/>
	</div>
	<p class="font-bold text-xl mb-5">You've successfully created an account!</p>
	<p class="mb-14 text-center">
		It's time to move over to your desktop to enjoy all Closer has to offer
	</p>
	<div class="w-full mb-8">
		<img
			src="/assets/images/empty-states/dashboard-mobile.svg"
			alt="Closer"
			class="w-full mb-5"
		/>
	</div>
	<p class="mb-5 text-center">
		If you have any question, feel free to reach out to us.
	</p>
	<div class="flex justify-evenly mb-14 w-full">
		<a
			class="bot-trigger--feedback flex flex-col items-center cursor-pointer"
			[testHook]="testHooks.ChatLink"
		>
			<div class="mobile-icon">
				<app-icon
					[icon]="ICON.MESSAGE"
					[testHook]="testHooks.MessageIcon"
				></app-icon>
			</div>
			<span>Chat</span>
		</a>
		<a
			emailLinkInterceptor
			href="mailTo:support@lawlabs.ca"
			class="flex flex-col items-center cursor-pointer"
			[testHook]="testHooks.EmailLink"
		>
			<div class="mobile-icon">
				<app-icon
					[icon]="ICON.EMAIL"
					[testHook]="testHooks.EmailIcon"
				></app-icon>
			</div>
			<span>Email</span>
		</a>
		<a
			externalNavInterceptor
			href="tel:+1-888-520-4004"
			target="_blank"
			class="flex flex-col items-center cursor-pointer"
			[testHook]="testHooks.PhoneLink"
		>
			<div class="mobile-icon">
				<app-icon
					[icon]="ICON.PHONE"
					[testHook]="testHooks.PhoneIcon"
				></app-icon>
			</div>
			<span>Phone</span>
		</a>
	</div>
	<div class="legal">
		<div>&copy; Copyright {{ year }} LawLabs Inc.</div>
		<div class="flex flex-row gap-10 ml-3 justify-center">
			<a
				emailLinkInterceptor
				class="font-bold cursor-pointer"
				href="mailto:support@lawlabs.ca"
				[testHook]="testHooks.ContactLink"
				>Contact</a
			>
			<a
				[routerLink]="legalUrl"
				class="font-bold cursor-pointer"
				[testHook]="testHooks.LegalLink"
				>Legal</a
			>
		</div>
	</div>
</div>

<div
	class="main hidden sm:grid print-block relative bg-green-950"
	*ngIf="loaded$ | async; else showLoading"
	[ngClass]="{
		'sm:grid-cols-[88px_1fr]': showSideNav$ | async,
		'bg-gray-50': _grayBg,
	}"
>
	<app-navbar />
	<div
		class="main-router-wrapper print-block print-fit-page-width rounded-tl-2xl print:rounded-none bg-white"
		#main
	>
		<router-outlet class="hidden-router"></router-outlet>
	</div>
</div>

<div
	id="backdrop"
	[class.hidden]="!(backdropState$ | async)"
	class="h-screen w-screen z-popup absolute overflow-hidden opacity-0"
></div>
<ng-template #showLoading>
	<atomic-loading-icon [testHook]="testHooks.LoadingIcon"></atomic-loading-icon>
</ng-template>
